import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { FILL } from '../../../../../../redux/actions/app/fill/fill.actions';
import { getLoadingEntity } from '../../../../../../redux/selectors/ui/ui.selectors';
import NumeroTel from './NumeroTel';
import {
    getCanalDemandeTarifInit,
    getIsComparateurApporteur,
    getParrainageTelPortableInit,
    getTypeMERInit
} from "../../../../../../redux/selectors/init/init.selectors.js";

const mapStateToProps = (state) => {
    const selector = formValueSelector('devis-direct');

    return {
        loadingPostFill: getLoadingEntity(state, FILL),
        needCaptcha: selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][3][DatePermis]') === selector(state, 'DemandeTarif[ListePersonnes][0][ListePermis][4][DatePermis]'),
        isComparateur: getIsComparateurApporteur(state),
        canal: getCanalDemandeTarifInit(state),
        isAppGPT: ['AppGPT', 'AgentConv'].includes(getTypeMERInit(state)),
        telPortableParrainage: getParrainageTelPortableInit(state),
    };
};

const NumeroTelContainer = connect(mapStateToProps)(NumeroTel);

export default NumeroTelContainer;
